<div class="dialog-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="d-grid gap-14">
        <div class="grid-container">
            <div class="form-group">
                <app-input context="Normal" class="form-item" label="Event region name" [required]="true"
                    placeholder="Enter your region name" type="text" [control]="form.get('eventHostRegionName')"
                    formControlName="eventHostRegionName"
                    [customErrorMessages]="customErrorMessages.eventHostRegionName">
                </app-input>
            </div>
            <div class="form-group">
                <app-input context="Normal" class="form-item" label="Region initial"
                    placeholder="Enter your region initial" [optional]=true type="text"
                    [control]="form.get('eventHostRegionInitial')" formControlName="eventHostRegionInitial"
                    [customErrorMessages]="customErrorMessages.eventHostRegionInitial">
                </app-input>
            </div>
        </div>
        <div class="toggle-container">
            <label class="toggle-text">
                <span>Status</span>
                <input id="status" formControlName="status" type="checkbox" class="toggle-input" />
                <span class="toggle-switch"></span>
            </label>
        </div>

        <button type="submit" style="display: none;" #submitBtn></button>
    </form>
</div>